import gql from 'graphql-tag';

import { Query } from 'core';
import { Subscription } from 'core/subscription';

const MESSAGE_FIELDS_FRAGMENT = gql`
  fragment messageFields on Message {
    id
    messageType
    body
    snippet(maxLength: 100)
    contextId
    referenceId
    resourceId
    tempKey
    createdBy {
      id
      email
      locale
      profile {
        id
        type
        slug
        fullName
        avatar {
          id
          url
        }
      }
      emailsEnabled
      asSpace {
        id
        spaceType
        content {
          title
          slug
        }
      }
    }
    updatedAt
    timestamp
  }
`;

// const RFQ_CONNECTION_QUERY = gql`
//   ${RFQLIST_FIELD_FRAGMENT}

//   query RFQs(
//     $first: Int
//     $offset: Int
//     $sortField: String
//     $sortOrder: SortOrder
//     $filters: [FilterInput!]
//     $spaceId: ID
//   ) {
//     requestForQuotes(
//       first: $first
//       offset: $offset
//       sortField: $sortField
//       sortOrder: $sortOrder
//       filters: $filters
//       spaceId: $spaceId
//     ) {
//       total
//       nodes {
//         ...rfqFields
//       }
//     }
//   }
// `;

// id: ID!
// contextId: String!
// resourceId: String
// reference: Node
// messages(
//   first: Int
//   offset: Int
//   sortOrder: SortOrder
//   filters: [FilterInput!]
// ): MessagePage!
// unreadCount: Int!
// lastMessage: Message

const CONVERSATION_FIELDS_FRAGMENT = gql`
  ${MESSAGE_FIELDS_FRAGMENT}
  fragment conversationFields on Conversation {
    id
    type
    contextId
    resourceId
    unreadCount
    lastUpdatedAt
    context {
      id
      parentObj {
        id
        name
        title
      }
    }
    lastMessage {
      ...messageFields
    }
    uri
  }
`;
// messages(
//   first
//   offset
//   sortOrder
//   filters
// ) {
//   nodes {
//     ...messageFields
//   }
//   total
// }

// $filters
// filters: [FilterInput!]
export const CONVERSATIONS_CONNECTION_QUERY = gql`
  ${CONVERSATION_FIELDS_FRAGMENT}
  query Conversations($first: Int, $offset: Int) {
    conversations(first: $first, offset: $offset) {
      total
      totalUnread
      nodes {
        ...conversationFields
      }
    }
  }
`;

export const INBOX_SUBSCRIPTION = gql`
  subscription Inbox {
    inbox {
      id
    }
  }
`;

export class InboxSubscription extends Subscription {
  static conf = {
    GQL: INBOX_SUBSCRIPTION,
    resultPath: 'inbox',
  };
}

export class ConversationsConnectionQuery extends Query {
  static conf = {
    GQL: CONVERSATIONS_CONNECTION_QUERY,
    resultPath: 'conversations',
    varNames: ['first', 'offset'],
    //
    // inputName: ['first', 'offset', 'sortField', 'sortOrder', 'filters'],
  };
}

const CONVERSATIONS_POLL_QUERY = gql`
  query ConversationsPoll($first: Int, $offset: Int) {
    conversations(first: $first, offset: $offset) {
      total
      totalUnread
    }
  }
`;

export class InboxPollQuery extends Query {
  static conf = {
    GQL: CONVERSATIONS_POLL_QUERY,
    varNames: ['first', 'offset'],
    resultPath: 'conversations',
    //
    // inputName: ['first', 'offset', 'sortField', 'sortOrder', 'filters'],
  };
}
